import React from 'react'

export default function ProductsListHeaderStyle({signed_in}) {
  let tb_buttons_display = null
  if (signed_in !== 'admin')
    tb_buttons_display = { products_fc: (signed_in.user_access.products_fc) ? 'block' : 'none' }
  else  tb_buttons_display = { products_fc: 'block' }

  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #product-toolbar {
          display: flex;
          padding: 5px 0;
        }

        /* Show or hide these toolbar buttons */
        #add-new-product, #find-and-replace, #select-all, #batch-delete {
          display: ${tb_buttons_display.products_fc};
        }

        .messagebox {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .messagebox-content {
          flex: 2;
          height: 100%;
        }

        .button-container {
          display: flex;
          justify-content: flex-end;
        }

      `}
      </style>
    </React.Fragment>
  )
}
